import ResetPassword from 'components/ResetPassword';

export default ResetPassword;
